import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info-hint"
}
const _hoisted_2 = { class: "enemy-name" }
const _hoisted_3 = { class: "summary-text" }
const _hoisted_4 = {
  key: 0,
  class: "stat-sheet"
}
const _hoisted_5 = { class: "ability-details" }
const _hoisted_6 = { class: "ability-label" }
const _hoisted_7 = { class: "ability-desc" }

import { computed, inject } from 'vue';
import { chevronUp, chevronDown, eyeOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/vue';
import { GameEvents } from '@/lib/GameEvents';
import HexBadge from './HexBadge.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EnemyInfoBar',
  setup(__props) {

const game = inject('game') as any;
const examine = computed(() => game.state.examine);

const isVisualizeMode = computed(() => game.state.gameplay.currentActionMode === 'VISUALIZE');

const summaryText = computed(() => {
  const infos = examine.value.displayInfos;
  if (!infos || infos.length === 0) return '';
  return infos.map((i: any) => i.label).join(' · ');
});

const toggleExpanded = () => {
  game.emit(GameEvents.ENEMY_STAT_SHEET_TOGGLED);
};

return (_ctx: any,_cache: any) => {
  return (isVisualizeMode.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["enemy-info-card", { expanded: examine.value.expanded }])
      }, [
        (!examine.value.examinedEnemyId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonIcon), {
                icon: _unref(eyeOutline),
                class: "hint-icon"
              }, null, 8, ["icon"]),
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Tap any creature to examine it", -1))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "info-summary",
                onClick: toggleExpanded
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(examine.value.enemyName), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(summaryText.value), 1),
                _createVNode(_unref(IonIcon), {
                  icon: examine.value.expanded ? _unref(chevronUp) : _unref(chevronDown),
                  class: "expand-icon"
                }, null, 8, ["icon"])
              ]),
              (examine.value.expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examine.value.displayInfos, (info, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "ability-row"
                      }, [
                        _createVNode(HexBadge, {
                          icon: info.icon,
                          label: info.label
                        }, null, 8, ["icon", "label"]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(info.label), 1),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(info.description), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ], 2))
    : _createCommentVNode("", true)
}
}

})